export default __webpack_public_path__ + "static/media/chapter_7.ac051aa5.png";